import { createContext } from 'react';

export interface WorkflowInterface {
  action?: {
    type?: string;
  };
  name?: string;
  index?: number;
  trigger_value?: string;
  enabled: boolean;
  type: string;
}

export interface ConfigurationContextValue {
  isEditWorkflowMode: boolean;
  setIsEditWorkflowMode: (isEditWorkflowMode: boolean) => void;
  selectedWorkflow: WorkflowInterface | null;
  setSelectedWorkflow: (selectedWorkflow: WorkflowInterface | null) => void;
}

export const ConfigurationContext = createContext<ConfigurationContextValue | null>(null);
